// Only layout geometry crosses the iframe boundary. Never include booking data.
export const CHANNEL = 'tebole.booking.ui';
export const VERSION = 1;
export const packet = (type, geometry = {}) => Object.assign({ channel: CHANNEL, version: VERSION, type }, geometry);
export const isPacket = data => !!data && typeof data === 'object' && data.channel === CHANNEL && data.version === VERSION;
export const numberInRange = (value, min, max) => typeof value === 'number' && Number.isFinite(value) && value >= min && value <= max;
export const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export function visibleFrame(rect, viewportHeight, offset = 0) {
  const top = clamp(offset - rect.top, 0, rect.height);
  const bottom = clamp(viewportHeight - rect.top, 0, rect.height);
  return { top, height: Math.max(0, bottom - top) };
}
